export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => {
    return (
      +c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
    ).toString(16);
  });
}

export function updateVH() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");
}

export function createElement(
  tagName: string,
  className?: string,
): HTMLElement {
  const element = document.createElement(tagName);

  if (className) {
    element.className = className;
  }

  return element;
}

export function createTextElement(
  content: string,
  className?: string,
): HTMLSpanElement {
  const span = createElement("span", className);
  span.textContent = content;

  return span;
}
